<template>
  <div class="ex-tool">
    <div class="tool_item1 img_block" @click="makeVisit" v-if="false">
      <img src="@/assets/img/new/visit.png" >
    </div>
    <!-- <div class="tool_item1 img_block" v-if="isInquiry" @click="askforClick">
     <img src="@/assets/img/new/ask_for.png" >
    </div> -->
    <div class="tool_item1" @click="go_Dview" v-if="isD">
      <!-- <i class="iconfont icon-d icon"></i>
      <p style="color:#ff4b2b">3D</p> -->
      <img src="@/assets/img/dongtu.gif"  style="width:0.92rem;height:0.92rem">
    </div>
    <!-- <div class="tool_item1" @click="like" v-if="!isLike" >
      <i class="iconfont icon-dianzanxuanzhong" ></i>
      <p>{{formatLikeCount}}</p>
    </div>
    <div class="tool_item1" @click="like" v-else >
      <i class="iconfont icon-dianzanxuanzhong"  style="color: #ff5c00" ></i>
      <p style="color: #ff5c00">{{formatLikeCount}}</p>
    </div> -->
    <div class="tool_item1" @click="share" v-if="isWeixin">
      <i class="iconfont icon-zhuanfa"></i>
      <p>{{formatShareCount ? formatShareCount : ' - '}}</p>
    </div>
    <div class="tool_item1 go_top" v-if="isShowTop" @click="goTop">
      <i class="iconfont icon-huidingbu"></i>
    </div>
    <div class="tool_item1 no_go_top" v-else></div>
  </div>
</template> 

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "ex-tool",
  props:{
    likeCount:{
      type: Number,
      default: 0
    },
    shareCount:{
      type: Number,
      default: 0
    },
    isLike:{
      type:Boolean,
      default:false,
    },
    isInquiry:{
      type:Boolean,
      default:false,
    },
    isD:{
      type:Boolean,
      default:false,
    }
  },
  components:{
  },
  data() {
    return {
      isShowTop:false,
      scroll_:null,
    };
  },
  created(){
  },
  mounted(){
    this.scroll_=()=>{
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scrollTop);
      if(scrollTop>500){
        this.isShowTop=true
      }else{
        this.isShowTop=false
      }
    }
    window.addEventListener('scroll',this.scroll_)
  },
  computed: {
    ...mapGetters({
      isWeixin: "getIsWeixin",
    }),
    formatLikeCount(){
      let num=this.likeCount;
      if(num >= 10000) {
          num = Math.round(num/1000)/10 + 'w';
      } else if (num >= 1000) {
          num = Math.round(num/100)/10 + 'k';
      }
      return num
    },
    formatShareCount(){
      let num=this.shareCount;
      if(num >= 10000) {
          num = Math.round(num/1000)/10 + 'w';
      } else if (num >= 1000) {
          num = Math.round(num/100)/10 + 'k';
      }
      return num
    },
  },
  beforeDestroy(){
    if(this.scroll_){
      window.removeEventListener('scroll',this.scroll_)
    }
  },
  methods: {
    ...mapActions({
     
    }),
    //预约参观
    makeVisit(){
      this.$emit('makeVisit')
    },
    //索取样品
    askforClick(){
      this.$emit('askforClick');
    },
    //点赞点击
    like(){
      console.log(this.isLike,'isLike')
      this.$emit('like');
    },
    //分享点击
    share(){
      this.$emit('share');
    },
    go_Dview(){
      this.$emit('go_Dview')
    },
    //回到顶部
    goTop(){
      $('html , body').stop().animate({scrollTop: 0},'1000');
    },
  }
};
</script>
<style scoped lang="scss">
.ex-tool{
  width:1rem;
  display: flex;
  flex-direction:column;
  justify-content: center;
  align-items: center;
  .tool_item1{
    width: 0.92rem;
    height: 0.92rem;
    background: #fff;
    box-shadow: 0px 3px 10px 0px 	rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color:#666;
    margin-top: 0.4rem;
    &:first-child{
      margin-top: 0;
    }
    &.img_block{
      width: 1rem;
      height: 1rem;
      // box-shadow: none;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .iconfont{
      font-size: 0.34rem;
      &.icon-zhuanfa{
        transform: scale(1.5) translateX(0.01rem);
      }
      &.icon-dianzanxuanzhong{
        transform: scale(1.3) translateY(-0.04rem);
        margin-top: 0.08rem;
      }
      &.icon-d{
        transform: scale(1.5) translateX(0.01rem);
      }
    }
    .icon{
      // background:linear-gradient(90deg, #ff416c 0%,#ff4b2b 100%);
      // -webkit-background-clip: text;
      // color: transparent;
      color:#ff4b2b;
    }
    p{
      font-size: 0.2rem;
    }
    &.no_go_top{
      background: rgba(0, 0, 0, 0);
      box-shadow:none
    }
    &.go_top{
      .iconfont{
        transform: scale(1.6);
      }
    }
  }

}
</style>
